export enum LayoutColor {
  primary = 0xdd3420,
  warning = 0xdd6720,
}
